export const languageStringsPopups = {
  deletionWasSuccessful: "Usunięcie zakończyło się pomyślnie.",
  saveWasSuccessful: "Zapisano pomyślnie",
  visualChanged: "Wygląd został ustawiony pomyślnie.",
  notificationAdded: "Notyfikacja została dodana.",
  setButtonText: "Ustaw tekst przycisku.",
  missingHttp: 'Url powinien rozpoczynać się od "http" lub "https".',
  addNameAndText: "Dodaj nazwę notyfikacji i tekst.",
  textMustBeFilled: "Tekst notyfikacji musi zostać wypełniony.",
  connectionMissing:
    'Przynajmniej jedna pozycja musi być spełniona w "Parowaniu".',
  added: "Dodano.",
  fillAllFields: "Wypełnij wszystkie pola",
  fillApiKey: "Wprowadź klucz API",
  webCreatedSuccessfully: "Strona internetowa została pomyślnie utworzona.",
  notVerified: "Nie zweryfikowano",
  changesSaved: "Zmiany zostały zapisane pomyślnie",
  changeSubscriptionDisabled: "Zmiana warunków abonamentu jest zabroniona",
  subscriptionChangedTo: "Abonament zmieniono na: ",
  subscriptionCanceled: "Rezygnacja z abonamentu była pomyślna",
  nameIsEmpty: "Imię nie może być puste",
  cannotCreateNotification: "Nie udało się utworzyć notyfikacji.",
  fillApiAndPlaceId: "Wprowadź klucz API i identyfikator miejsca.",
  verificationFailed: "Weryfikacja nie powiodła się.",
  apiKeyVerificatedSuccess: "Klucz API został pomyślnie zweryfikowany.",
  fillApiAndBusinessUnitId:
    "Wprowadź klucz API i identyfikator jednostki biznesowej.",
  googleReviewsWasVerified: "Google Reviews zostało pomyślnie zweryfikowane.",
};
